export * from './public_api';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/database/index.js
// module id = 170
// module chunks = 4